define([
	"dojo/_base/declare",
	"csi/action/AggregateController",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType"
], function(declare, AggregateController, xml, Query, ProductType) {

	const BOM_PRODUCT_TYPE = "BOMProductType";
	const BOM_PRODUCT_TYPES = "BOMProductTypes";
	const PLACEMENT_PRODUCT_TYPE = "PlacementProductType";
	const THEME = "Theme";
	const PRODUCT_SOURCE = "ProductSource";

	return declare(AggregateController, {

		_getFixedFilters: function() {

			const query = this._getFixedFiltersQuery(this.m_cache, this.getParent());

			return query.getElements();
		},

		_getFixedFiltersQuery: function(cache, parent) {
			const query = new Query();
			let bomParent = cache.getPathNode(parent, "Child:__Parent__/Child:__Parent__");

			query.Attr(BOM_PRODUCT_TYPE, xml.OP_EQUALS, "ProductType:" + this._getFilterProductType(bomParent));
			query.Attr("Active", xml.OP_EQUALS, true);

			if (bomParent) {
				const isAssortment = ProductType.get(bomParent, "IsAssortment");
				if (!isAssortment) {
					query.Attr(PLACEMENT_PRODUCT_TYPE, xml.OP_NOT_EQUALS, "ProductType:Style");
				}

				if (bomParent.$Type !== THEME) {
					query.Or().Attr(BOM_PRODUCT_TYPES, xml.OP_NULL)
						.RefAttr(BOM_PRODUCT_TYPES, xml.OP_EQUALS, bomParent.ProductType);
				}
			}

			return query;
		},

		_getFilterProductType: function(product) {
			if (product && product.$Type !== THEME && product.$Type !== PRODUCT_SOURCE) {
				return product.$Type
			} else {
				return "Style";
			}
		}
	});
});
